import axios from 'axios';

export default {
	getFirstPastDay() {
		return axios.get('/api/days/past/first');
	},
	getFirstLockedDay() {
		return axios.get('/api/days/locked/first');
	},
	getDaysByStatus(status) {
		return axios.get(`/api/days?from=${status}&to=${status}&fields=date`);
	},
};
